<template>
  <div>

    <body
      class="login-container"
      style="background-color: white"
    >
      <!-- Page container -->
      <div class="page-container">
        <!-- Page content -->
        <div class="page-content">
          <!-- Main content -->
          <div class="content-wrapper">
            <!-- Content area -->
            <div class="content pb-20">
              <!-- Tabbed form -->
              <div
                class="tabbable panel login-form width-400"
                style="margin-top: 20px"
              >
                <ul class="nav nav-tabs nav-justified">
                  <li
                    style="background-image: radial-gradient(circle farthest-corner at 10% 20%,rgba(0, 107, 141, 1) 0%,rgba(0, 69, 91, 1) 90%);"
                    class="active"
                  >
                    <a
                      href="#basic-tab1"
                      data-toggle="tab"
                    >
                      <img
                        src="../../assets/images/shipzone.png"
                        width="150px"
                        alt="shipzone logo"
                      />
                      <!-- <h6 style="color: white">Sign in</h6> -->
                    </a>
                  </li>
                </ul>

                <div class="tab-content panel-body">
                  <div
                    class="tab-pane fade in active"
                    id="basic-tab1"
                  >
                    <div class="text-center">
                      <h5 class="content-group">Login to your account with</h5>
                    </div>

                    <div class="d-flex mb-4 pb-2">
                      <v-btn
                        style="height:auto;"
                        :style="activeTab == 1 ? 'color: white; background-color: #323232;' : 'color: #333; background-color: #fff'"
                        @click="activeTab = 1"
                      >
                        Phone Number
                      </v-btn>

                      <v-btn
                        style="height:auto"
                        :style="activeTab == 2 ? 'color: white; background-color: #323232;' : 'color: #333; background-color: #fff'"
                        @click="activeTab = 2"
                      >
                        Google or Facebook
                      </v-btn>
                    </div>

                    <template v-if="activeTab == 1">
                      <form @submit.prevent="loginWithPhoneAndPassword()">
                        <v-layout wrap>
                          <v-flex xs12>
                            <div class="d-flex align-center">
                              <div
                                class="mr-2"
                                style="font-size: 15px"
                              >+964</div>
                              <v-text-field
                                label="Phone Number"
                                placeholder="7xxxxxxxxx"
                                v-model="formData.phone_number"
                                :error-messages="errors.collect('Phone Number')"
                                v-validate="'required|min:10|max:10'"
                                data-vv-name="Phone Number"
                              />
                            </div>
                          </v-flex>

                          <v-flex xs12>
                            <v-text-field
                              ref="passwordField"
                              label="Password"
                              v-model="formData.password"
                              :error-messages="errors.collect('Password')"
                              v-validate="'required'"
                              data-vv-name="Password"
                              :append-icon="e1 ? 'visibility_off' : 'visibility'"
                              :append-icon-cb="() => (e1 = !e1)"
                              :type="e1 ? 'text' : 'password'"
                            />
                          </v-flex>

                          <v-flex xs12>
                            <v-btn
                              type="submit"
                              :loading="loading"
                              style="height:auto; margin-right: 2%"
                              color="primary"
                            >
                              Login
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </form>
                    </template>

                    <template v-else>
                      <v-flex
                        sm12
                        md
                        12
                      >
                        <v-btn
                          @click="auth('facebook')"
                          style="height:auto; width:100%; color: white; background-color: #3b5998; margin: 0px"
                        ><i class="fa fa-facebook-f fa-2x"></i> &nbsp; &nbsp; Facebook</v-btn>
                      </v-flex>

                      <div
                        style="margin-top: 5%"
                        class="content-divider text-muted form-group"
                      >
                        <span>or</span>
                      </div>
                      <v-flex
                        sm12
                        md12
                      >
                        <GoogleLogin
                          class="glogin-btn"
                          :params="params"
                          :onSuccess="googleLogin"
                          :onFailure="onFailure"
                        >
                          <img
                            src="../../assets/images/google_logo.png"
                            width="30px"
                          /> &nbsp; Google
                        </GoogleLogin>
                      </v-flex>
                    </template>
                  </div>
                </div>
              </div>
              <!-- /tabbed form -->
            </div>
            <!-- /content area -->
          </div>
          <!-- /main content -->
        </div>
        <!-- /page content -->
      </div>
      <!-- /page container -->
    </body>

    <!-- <router-view></router-view> -->

    <div
      id="modal_showApp"
      class="modal fade"
    >
      <div
        class="modal-dialog modal-full"
        style="max-width:450px"
      >
        <div class="modal-content">
          <div class="modal-header">
            <button
              title="close"
              type="button"
              class="close"
              @click="closeModal('modal_showApp')"
            >
              &times;
            </button>
          </div>

          <div class="modal-body">
            <div class="col-sm-9">
              <h4 class="lead">Please verify your phone number</h4>
            </div>
            <div class="col-sm-3">
              <v-btn
                id="sms"
                @click="smsLogin(), closeModal('modal_showApp')"
                style="padding-left: 0px; padding-right: 0px; height:auto; color: white; background-color: #FF6F00"
              >Verify</v-btn>
            </div>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import GoogleLogin from 'vue-google-login'

export default {
  props: ['changeLogin', 'changePhoneLogin'],

  components: {
    GoogleLogin
  },

  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      e1: false,
      activeTab: 1,
      loading: false,
      formData: {
        phone_number: null,
        password: null
      },
      params: {
        client_id: '17629677592-96u7gdi6phhtb1t02lajhauf7dnir6ul.apps.googleusercontent.com'
        // client_id: '252910102757-b65d5qvd0nutbnemjq8prbssv4pt9i5n.apps.googleusercontent.com'
      },
      fromFacebook: false,
      facebookData: {
        email: '',
        full_name: '',
        facebook_id: '',
        phone_number: ''
      },
      googleData: {
        the_google_id: null,
        full_name: '',
        email: ''
      },
      phoneData: {
        code: '',
        csrf: ''
      },
      phoneUserData: {
        phone_number: ''
      }
    }
  },
  methods: {
    googleLogin(gData) {
      let data = Object.entries(gData)
      let theData = Object.entries(data[2][1])

      this.googleData.the_google_id = theData[0][1]
      this.googleData.full_name = theData[1][1]
      this.googleData.email = theData[5][1]
      this.changeLogin(this.googleData)
    },

    onFailure(error) {
      console.log(error)
    },

    auth(network) {
      const hello = this.hello
      hello(network)
        .login()
        .then(() => {
          const authRes = hello(network).getAuthResponse()
          hello(network)
            .api('me')
            .then((json) => {
              this.fromFacebook = true
              this.facebookData.email = json.email
              this.facebookData.full_name = json.name
              this.facebookData.facebook_id = json.id
              this.changeLogin(this.facebookData)
              this.checkPhoneVerification(json.id)
            })
        })
    },

    checkPhoneVerification(facebookId) {
      axios.get('/api/check_phone_verification/' + facebookId).then((response) => {
        if (response.data.success == true) {
          this.facebookData.phone_number = response.data.data.phone_number
          this.changeLogin(this.facebookData)
        } else {
          $('#modal_showApp').modal({ backdrop: 'static' })
        }
      })
    },

    loginCallback(response) {
      if (response != null) {
        if (response.status === 'PARTIALLY_AUTHENTICATED') {
          this.phoneData.code = response.code
          this.phoneData.csrf = response.state
          $('#phone').click()
        }
      }
    },

    smsLogin() {
      // eslint-disable-next-line no-undef
      AccountKit.login('PHONE', { countryCode: '+964' }, this.loginCallback)
    },

    phoneLogin() {
      axios.post('/api/phone-login', this.phoneData).then((response) => {
        if (this.fromFacebook == true) {
          this.facebookData.phone_number = response.data.data.phone.number
          this.changeLogin(this.facebookData)
        } else {
          this.phoneUserData.phone_number = response.data.data.phone.number
          this.changeLogin(this.phoneUserData)
        }
      })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    loginWithPhoneAndPassword() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          let payload = { ...this.formData }
          // replace all white spaces in phone number
          payload.phone_number = payload.phone_number.replace(/\s+/g, '')

          // append country code
          payload.phone_number = '+964' + payload.phone_number
          this.changePhoneLogin(payload)
        }
      })
    }
  }
}
</script>

<style>
.glogin-btn {
  width: 100%;
  color: #333;
  background-color: #fff;
  padding: 6px;
  border-radius: 5px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}
.glogin-btn:hover {
  background-color: #ddd;
}
.icons {
  color: #000;
}

.icons:hover {
  color: #999999;
}

.the-li {
  display: inline;
  text-transform: uppercase;
  font-family: Raleway, Arial, sans-serif;
  padding: 6px;
  font-size: 15px;
}

li a {
  color: #5e5e5e;
}

li a:hover {
  color: #999999;
}

.dot {
  height: 3px;
  width: 3px;
  background-color: #5c5c5c;
  border-radius: 50%;
  display: inline-block;
  margin-bottom: 4px;
}

#social {
  border-bottom-style: solid;
  border-width: 1px;
  border-color: black;
  padding-left: 6%;
  padding-bottom: 9px;
  padding-top: 10px;
  border-color: #ebebeb;
}

#list-section {
  border-bottom-style: solid;
  border-width: 1px;
  border-color: black;
  padding-left: 6%;
  padding-bottom: 9px;
  padding-top: 10px;
  border-color: #ebebeb;
}

.login-container .page-container {
  padding-top: 0px;
}

.modal {
  text-align: center;
  padding: 0 !important;
}

.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -4px;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

#navbar-mobile {
  padding-left: 300px;
}
@media screen and (max-width: 767px) {
  .the-li {
    display: block;
    text-transform: uppercase;
    font-family: Raleway, Arial, sans-serif;
    padding: 6px;
    font-size: 15px;
    text-align: left;
    line-height: 65px;
  }

  .dot {
    display: none;
  }

  #navbar-mobile {
    padding-left: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loginComponent.vue